import { IPaths } from "~/types/routing";

export const paths: IPaths = {
  index: "/background-generator",
  generate: "/background-generator/new",
  generated: "/background-generator/:id",
  edit: "/background-generator/:id/edit",
};
